(() => {
  document.addEventListener('click', event => {
    const card = event.target.closest('[data-pick-variant]');
    if (!card) return;
    const select = document.querySelector('[data-variant-select]');
    if (!select || ![...select.options].some(option => option.value === card.dataset.pickVariant)) return;
    event.preventDefault();
    select.value = card.dataset.pickVariant;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    document.querySelector('#shop')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
})();
